import { createContext } from 'react';
import i18n from './i18n';
import i18nServerError from './i18nServerError';
export default createContext({
  lang: 'en',
  i18n: i18n('en'),
  i18nServerError: i18nServerError('en')
});